import React from 'react';
import { profiles } from '../../data/profiles';
import { ProfileCard } from '../ProfileCard';
import { CtaButton } from '../CtaButton';
export function ProfilePaths() {
  return <section className="bg-white py-12 lg:py-20" aria-labelledby="profiles-title" data-id="element-396" data-mp="1gfp87hncu4jq">
      <div className="mx-auto max-w-6xl px-5" data-id="element-397" data-mp="1gdcuxhsjkid0">
        <div className="mx-auto max-w-3xl text-center" data-id="element-398" data-mp="1cdu6wd5fbr5y">
          <h2 id="profiles-title" className="font-display text-[26px] font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-399" data-mp="1cc9hf1xyuyey">
            ¿Querés empezar a trabajar con adultos mayores <span className="text-brand-600" data-id="element-400" data-mp="jnlnkhz5j0ps">o ya trabajás con ellos?</span>
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-401" data-mp="xixwbta56rpp">
            REACTIVA TU CUERPO fue creado para acompañarte en cualquiera de los dos caminos: prepararte para incorporar el trabajo con{' '}
            <strong className="font-semibold text-ink" data-id="element-402" data-mp="z6yw1cb3ys5">personas mayores </strong> a tus servicios profesionales o ayudarte a mejorar y ampliar las herramientas que ya utilizás.
          </p>
        </div>

        <div className="mt-8 grid gap-4 lg:mt-12 lg:grid-cols-2 lg:gap-6" data-id="element-403" data-mp="1mz0wg6eej9hm">
          {profiles.map((p, i) => <ProfileCard key={p.id} profile={p} dark={i === 1} data-id="element-404" data-mp="1rqajr0cha0qc" data-mpi={i} />)}
        </div>

        <div className="mx-auto mt-8 max-w-4xl rounded-3xl bg-brand-600 px-5 py-8 text-center text-white sm:px-10 lg:mt-12 lg:py-10" data-id="element-405" data-mp="1rsd7fdq5rhrw">
          <p className="font-display text-lg font-extrabold uppercase leading-tight tracking-tight sm:text-2xl" data-id="element-406" data-mp="z24wo6xybznc">No importa en qué punto estés hoy.</p>
          <div className="mx-auto mt-4 grid max-w-3xl gap-2 text-left sm:grid-cols-2" data-id="element-407" data-mp="142ivcydnxx8p">
            <p className="rounded-2xl bg-white/10 p-3.5 text-sm font-semibold leading-snug" data-id="element-408" data-mp="18y7x98d5nq86">
              Si querés empezar, <span className="text-sun" data-id="element-409" data-mp="1dwj8nnj3m8si">te ayuda a prepararte.</span>
            </p>
            <p className="rounded-2xl bg-white/10 p-3.5 text-sm font-semibold leading-snug" data-id="element-410" data-mp="2keeptmyyoftk">
              Si ya trabajás con adultos mayores, <span className="text-sun" data-id="element-411" data-mp="pbjfsfrtkm7p">te ayuda a ampliar tus recursos.</span>
            </p>
          </div>

          <p className="mt-7 font-display text-2xl font-extrabold tracking-tight sm:text-3xl" data-id="element-412" data-mp="kcowzdtuqxnl">REACTIVA TU CUERPO™</p>
          <p className="mx-auto mt-1.5 max-w-2xl font-display text-sm font-bold uppercase leading-snug tracking-wide text-brand-50 sm:text-base" data-id="element-413" data-mp="ychkl0a30xrc">
            Formación profesional + recursos prácticos para trabajar con adultos mayores.
          </p>

          <div className="mx-auto mt-6 flex max-w-md justify-center sm:max-w-none" data-id="element-414" data-mp="6ixp09vrrltz">
            <CtaButton className="w-full sm:w-auto" data-id="element-415" data-mp="1ns3hc6a496f" />
          </div>
          <p className="mt-3 text-[11px] font-bold uppercase tracking-wider text-brand-50" data-id="element-416" data-mp="fedop7j7gv7h">
            Acceso inmediato • Contenido digital • Disponible desde cualquier dispositivo
          </p>
        </div>
      </div>
    </section>;
}